import AiEvolution from '../assets/Insights/AI-Evolution-Feature.webp'
import DataAnalytics from '../assets/Insights/data_analyticstrendsmin.avif'
import OutsourcingIT from '../assets/Insights/Outsourcing-Vs-In-House-IT-Support.jpg'
import TechTalentChallenges from '../assets/Insights/TechTalentChallenges.jpg'
import CustomSoftwareROI from '../assets/Insights/CustomSoftwareROI.png'
import CustomSoftwareGrowth from '../assets/Insights/Custom-Software-Development.jpg'
import FutureProofHiring from '../assets/Insights/FutureProofHiring.webp'
import SaaSCloudTech from '../assets/Insights/Saas.webp'
import ContractVsPermanent from '../assets/Insights/Contract-Staffing-vs-Permanent-Staffings.jpg'

export const InsightsListData = [
    {
        id: 9,
        title: "Contract vs. Permanent Hiring: What’s Right for Your Tech Team?",
        description:
            "In the tech industry, one size doesn’t fit all when it comes to hiring. Businesses need staffing strategies that are flexible, cost-effective, and aligned with their operational goals. At Nugala, we help companies make the right choice between contract and permanent hiring—or a blend of both.",
        link: "contract-vs-permanent-hiring",
        minutes: 5,
        image: ContractVsPermanent,
        category: "Staffing Services",
        isNew: true
    },
    {
        id: 8,
        title: "Building Resilient and Scalable SaaS Platforms with Cloud Technology",
        description:
            "SaaS platforms are reshaping the software landscape, and cloud-native development has emerged as a crucial component for business success. At Nugala, we specialize in building SaaS platforms that are scalable, secure, and resilient—equipped to support high-volume users and rapidly changing market demands.",
        link: "saas-cloud-technology",
        minutes: 6,
        image: SaaSCloudTech,
        category: "Software Solutions",
        isNew: true
    },
    {
        id: 7,
        title: "Future-Proof Hiring: Bridging the Tech Talent Gap with Strategic Staffing",
        description:
            "In a world where digital transformation defines success, the demand for skilled IT professionals is at an all-time high. At Nugala, we help organizations bridge this talent gap through innovative, strategic staffing solutions that align perfectly with their technical and business goals.",
        link: "future-proof-hiring",
        minutes: 5,
        image: FutureProofHiring,
        category: "Staffing Services",
        isNew: true
    },
    {
        id: 6,
        title: "How Custom Software Development Accelerates Business Growth",
        description:
            "In today’s hyper-competitive environment, businesses need more than off-the-shelf software to thrive. Custom software development has become a key driver of digital transformation and operational efficiency. By investing in tailored solutions, companies can boost productivity, address unique challenges, and scale operations effectively.",
        link: "custom-software-growth",
        minutes: 5,
        image: CustomSoftwareGrowth,
        category: "Software Solutions",
        isNew: true
    },
    {
        id: 1,
        title: "Top 5 Challenges in Tech Talent Acquisition and How Indian Staffing Firms Are Solving Them",
        description:
            "Explore how Indian staffing firms like Nugala are tackling the biggest challenges in tech recruitment — from sourcing top AI and data talent to streamlining hiring processes and ensuring cultural fit in a remote-first world.",
        link: "tech-talent-challenges-india",
        minutes: 4,
        image: TechTalentChallenges,
        category: "Staffing Services",
        isNew: false
    },
    {
        id: 2,
        title: "The Real ROI of Custom Software: Case Studies from Indian Enterprises to Global Clients",
        description:
            "Discover how custom software solutions are delivering measurable ROI through efficiency, scalability, and competitive edge. Explore case studies from Indian enterprises to global clients, including Nugala's digital transformation success.",
        link: "custom-software-roi",
        minutes: 4,
        image: CustomSoftwareROI,
        category: "Software Solutions",
        isNew: false
    },
    {
        id: 3,
        title: "How AI-Powered Solutions Are Revolutionizing Business Operations Across Industries",
        description:
            "AI is transforming industries by driving automation, predictive analytics, and data-driven decision-making. From healthcare and finance to retail and logistics, discover how businesses are leveraging AI to optimize operations and accelerate growth.",
        link: "ai-evolution",
        minutes: 4,
        image: AiEvolution,
        category: "Software Solutions",
    },
    {
        id: 4,
        title: "The Future of Staffing: How AI and Data Analytics Are Revolutionizing Talent Acquisition",
        description:
            "Hiring the right talent is more competitive than ever. AI-powered recruitment solutions and data-driven insights are reshaping talent acquisition, enhancing candidate matching, and streamlining hiring processes for businesses worldwide.",
        link: "staffing-data-analytics",
        minutes: 5,
        image: DataAnalytics,
        category: "Staffing Services",
    },
    {
        id: 5,
        title: "Outsourcing vs. In-House Operations: Finding the Right Balance for Business Growth",
        description:
            "Should you keep operations in-house or outsource them for efficiency? This article explores the pros and cons of both models, helping businesses strike the perfect balance for scalability, cost savings, and operational success.",
        link: "outsourcing-vs-inhouse",
        minutes: 5,
        image: OutsourcingIT,
        category: "Software Solutions",
    }
];